import { createSelector } from 'reselect';
import { gettr } from '../../utils';

export const getFormData = createSelector(gettr('bookingForm', {}), formData => ({ formData }));

export const selectIsBooked = createSelector(gettr('bookingForm', {}), ({
    isBooked,
    error,
    isLoading,
}) => ({
    isBooked,
    error,
    isLoading,
}));

export const selectSelectedBranchName = createSelector(gettr('filters', {}), ({
    branches,
    selectedBranch,
}) => {
    const selectedBranchObj = branches.find(({ branchId }) => +branchId === +selectedBranch);
    return { branchName: !selectedBranchObj ? '' : selectedBranchObj.branch };
});

export const selectSelectedBranch = createSelector(gettr('filters', {}), ({
    branches,
    selectedBranch,
}) => ({ ...branches.find(({ branchId }) => branchId === selectedBranch) }));

export const getSuccessBookingData = createSelector([gettr('bookingForm', {})], ({ successBookingData = {} }) => successBookingData);
